"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GutterWidthContext = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var react_2 = require("@emotion/react");
var config_1 = require("../../config");
var ScreenClassResolver_1 = __importDefault(require("../../context/ScreenClassResolver"));
var style_1 = __importDefault(require("./style"));
exports.GutterWidthContext = (0, react_1.createContext)(20);
var Row = function (_a) {
    var children = _a.children, align = _a.align, justify = _a.justify, wrap = _a.wrap, noGutter = _a.noGutter, gutterWidth = _a.gutterWidth, _b = _a.component, component = _b === void 0 ? 'div' : _b, direction = _a.direction, rest = __rest(_a, ["children", "align", "justify", "wrap", "noGutter", "gutterWidth", "component", "direction"]);
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) {
            var theGutterWidth = 20;
            var gutterWidths = (0, config_1.getConfiguration)().gutterWidths;
            if (screenClass === 'xs' && gutterWidths[0]) {
                theGutterWidth = gutterWidths[0];
            }
            if (screenClass === 'sm' && gutterWidths[1]) {
                theGutterWidth = gutterWidths[1];
            }
            if (screenClass === 'md' && gutterWidths[2]) {
                theGutterWidth = gutterWidths[2];
            }
            if (screenClass === 'lg' && gutterWidths[3]) {
                theGutterWidth = gutterWidths[3];
            }
            if (screenClass === 'xl' && gutterWidths[3]) {
                theGutterWidth = gutterWidths[3];
            }
            if (noGutter)
                theGutterWidth = 0;
            if (typeof gutterWidth === 'number')
                theGutterWidth = gutterWidth;
            return (0, react_2.jsx)(component, __assign({ css: (0, style_1.default)({
                    gutterWidth: theGutterWidth,
                    align: align,
                    justify: justify,
                    direction: direction,
                    wrap: wrap,
                }) }, rest), (0, jsx_runtime_1.jsx)(exports.GutterWidthContext.Provider, __assign({ value: theGutterWidth }, { children: children })));
        } }));
};
exports.default = Row;
//# sourceMappingURL=index.js.map